module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "element element-container-single element-non-bodymatter element-type-toc",
    attrs: {
      "id": "table-of-contents"
    }
  }, [_c('div', {
    staticClass: "toc-heading"
  }, [_c('h3', {
    staticClass: "toc-title"
  }, [_vm._v("Contents")])]), _vm._v(" "), _c('div', {
    staticClass: "toc-contents"
  }, [_c('div', {
    staticClass: "toc-frontmatter-group"
  }, [_c('div', {
    staticClass: "toc-item toc-item-element-non-bodymatter toc-item-element-type-also-by has-no-leading-number has-no-children has-no-page-number"
  }, [_c('p', {
    staticClass: "element-title"
  }, [_c('a', {
    attrs: {
      "href": "#/booksinthecircuitfaeseriesbygenevieveiseulteldredge"
    }
  }, [_c('span', {
    staticClass: "element-title-text"
  }, [_vm._v("Books in The Circuit Fae Series By Genevieve Iseult Eldredge")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-bodymatter-group"
  }, [_c('div', {
    staticClass: "toc-item toc-item-element-bodymatter toc-item-element-type-chapter has-leading-number has-no-children has-no-page-number"
  }, [_c('p', {
    staticClass: "element-title"
  }, [_c('span', {
    staticClass: "element-number"
  }, [_vm._v("1. ")]), _c('a', {
    attrs: {
      "href": "#/chapter001"
    }
  }, [_c('span', {
    staticClass: "element-title-text"
  }, [_vm._v("SYL")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-element-bodymatter toc-item-element-type-chapter has-leading-number has-no-children has-no-page-number"
  }, [_c('p', {
    staticClass: "element-title"
  }, [_c('span', {
    staticClass: "element-number"
  }, [_vm._v("2. ")]), _c('a', {
    attrs: {
      "href": "#/chapter002"
    }
  }, [_c('span', {
    staticClass: "element-title-text"
  }, [_vm._v("ROUEN")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-element-bodymatter toc-item-element-type-chapter has-leading-number has-no-children has-no-page-number"
  }, [_c('p', {
    staticClass: "element-title"
  }, [_c('span', {
    staticClass: "element-number"
  }, [_vm._v("3. ")]), _c('span', {
    attrs: {
      "href": "#/chapter003",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "element-title-text"
  }, [_vm._v("SYL")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-element-bodymatter toc-item-element-type-chapter has-leading-number has-no-children has-no-page-number"
  }, [_c('p', {
    staticClass: "element-title"
  }, [_c('span', {
    staticClass: "element-number"
  }, [_vm._v("4. ")]), _c('span', {
    attrs: {
      "href": "#/chapter004",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "element-title-text"
  }, [_vm._v("ROUEN")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-element-bodymatter toc-item-element-type-chapter has-leading-number has-no-children has-no-page-number"
  }, [_c('p', {
    staticClass: "element-title"
  }, [_c('span', {
    staticClass: "element-number"
  }, [_vm._v("5. ")]), _c('span', {
    attrs: {
      "href": "#/chapter005",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "element-title-text"
  }, [_vm._v("SYL")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-element-bodymatter toc-item-element-type-chapter has-leading-number has-no-children has-no-page-number"
  }, [_c('p', {
    staticClass: "element-title"
  }, [_c('span', {
    staticClass: "element-number"
  }, [_vm._v("6. ")]), _c('span', {
    attrs: {
      "href": "#/chapter006",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "element-title-text"
  }, [_vm._v("DARK - ROUEN")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-element-bodymatter toc-item-element-type-chapter has-leading-number has-no-children has-no-page-number"
  }, [_c('p', {
    staticClass: "element-title"
  }, [_c('span', {
    staticClass: "element-number"
  }, [_vm._v("7. ")]), _c('span', {
    attrs: {
      "href": "#/chapter007",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "element-title-text"
  }, [_vm._v("SYL")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-element-bodymatter toc-item-element-type-chapter has-leading-number has-no-children has-no-page-number"
  }, [_c('p', {
    staticClass: "element-title"
  }, [_c('span', {
    staticClass: "element-number"
  }, [_vm._v("8. ")]), _c('span', {
    attrs: {
      "href": "#/chapter008",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "element-title-text"
  }, [_vm._v("DARK - ROUEN")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-element-bodymatter toc-item-element-type-chapter has-leading-number has-no-children has-no-page-number"
  }, [_c('p', {
    staticClass: "element-title"
  }, [_c('span', {
    staticClass: "element-number"
  }, [_vm._v("9. ")]), _c('span', {
    attrs: {
      "href": "#/chapter009",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "element-title-text"
  }, [_vm._v("SYL")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-element-bodymatter toc-item-element-type-chapter has-leading-number has-no-children has-no-page-number"
  }, [_c('p', {
    staticClass: "element-title"
  }, [_c('span', {
    staticClass: "element-number"
  }, [_vm._v("10. ")]), _c('span', {
    attrs: {
      "href": "#/chapter010",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "element-title-text"
  }, [_vm._v("DARK - ROUEN")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-element-bodymatter toc-item-element-type-chapter has-leading-number has-no-children has-no-page-number"
  }, [_c('p', {
    staticClass: "element-title"
  }, [_c('span', {
    staticClass: "element-number"
  }, [_vm._v("11. ")]), _c('span', {
    attrs: {
      "href": "#/chapter011",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "element-title-text"
  }, [_vm._v("SYL")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-element-bodymatter toc-item-element-type-chapter has-leading-number has-no-children has-no-page-number"
  }, [_c('p', {
    staticClass: "element-title"
  }, [_c('span', {
    staticClass: "element-number"
  }, [_vm._v("12. ")]), _c('span', {
    attrs: {
      "href": "#/chapter012",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "element-title-text"
  }, [_vm._v("DARK - ROUEN")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-element-bodymatter toc-item-element-type-chapter has-leading-number has-no-children has-no-page-number"
  }, [_c('p', {
    staticClass: "element-title"
  }, [_c('span', {
    staticClass: "element-number"
  }, [_vm._v("13. ")]), _c('span', {
    attrs: {
      "href": "#/chapter013",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "element-title-text"
  }, [_vm._v("SYL")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-element-bodymatter toc-item-element-type-chapter has-leading-number has-no-children has-no-page-number"
  }, [_c('p', {
    staticClass: "element-title"
  }, [_c('span', {
    staticClass: "element-number"
  }, [_vm._v("14. ")]), _c('span', {
    attrs: {
      "href": "#/chapter014",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "element-title-text"
  }, [_vm._v("DARK - ROUEN")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-element-bodymatter toc-item-element-type-chapter has-leading-number has-no-children has-no-page-number"
  }, [_c('p', {
    staticClass: "element-title"
  }, [_c('span', {
    staticClass: "element-number"
  }, [_vm._v("15. ")]), _c('span', {
    attrs: {
      "href": "#/chapter015",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "element-title-text"
  }, [_vm._v("SYL")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-element-bodymatter toc-item-element-type-chapter has-leading-number has-no-children has-no-page-number"
  }, [_c('p', {
    staticClass: "element-title"
  }, [_c('span', {
    staticClass: "element-number"
  }, [_vm._v("16. ")]), _c('span', {
    attrs: {
      "href": "#/chapter016",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "element-title-text"
  }, [_vm._v("DARK - ROUEN")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-element-bodymatter toc-item-element-type-chapter has-leading-number has-no-children has-no-page-number"
  }, [_c('p', {
    staticClass: "element-title"
  }, [_c('span', {
    staticClass: "element-number"
  }, [_vm._v("17. ")]), _c('span', {
    attrs: {
      "href": "#/chapter017",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "element-title-text"
  }, [_vm._v("SYL")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-element-bodymatter toc-item-element-type-chapter has-leading-number has-no-children has-no-page-number"
  }, [_c('p', {
    staticClass: "element-title"
  }, [_c('span', {
    staticClass: "element-number"
  }, [_vm._v("18. ")]), _c('span', {
    attrs: {
      "href": "#/chapter018",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "element-title-text"
  }, [_vm._v("DARK - ROUEN")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-element-bodymatter toc-item-element-type-chapter has-leading-number has-no-children has-no-page-number"
  }, [_c('p', {
    staticClass: "element-title"
  }, [_c('span', {
    staticClass: "element-number"
  }, [_vm._v("19. ")]), _c('span', {
    attrs: {
      "href": "#/chapter019",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "element-title-text"
  }, [_vm._v("SYL")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-element-bodymatter toc-item-element-type-chapter has-leading-number has-no-children has-no-page-number"
  }, [_c('p', {
    staticClass: "element-title"
  }, [_c('span', {
    staticClass: "element-number"
  }, [_vm._v("20. ")]), _c('span', {
    attrs: {
      "href": "#/chapter020",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "element-title-text"
  }, [_vm._v("ROUEN")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-element-bodymatter toc-item-element-type-chapter has-leading-number has-no-children has-no-page-number"
  }, [_c('p', {
    staticClass: "element-title"
  }, [_c('span', {
    staticClass: "element-number"
  }, [_vm._v("21. ")]), _c('span', {
    attrs: {
      "href": "#/chapter021",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "element-title-text"
  }, [_vm._v("SYL")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-element-bodymatter toc-item-element-type-chapter has-leading-number has-no-children has-no-page-number"
  }, [_c('p', {
    staticClass: "element-title"
  }, [_c('span', {
    staticClass: "element-number"
  }, [_vm._v("22. ")]), _c('span', {
    attrs: {
      "href": "#/chapter022",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "element-title-text"
  }, [_vm._v("ROUEN")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-element-bodymatter toc-item-element-type-chapter has-leading-number has-no-children has-no-page-number"
  }, [_c('p', {
    staticClass: "element-title"
  }, [_c('span', {
    staticClass: "element-number"
  }, [_vm._v("23. ")]), _c('span', {
    attrs: {
      "href": "#/chapter023",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "element-title-text"
  }, [_vm._v("SYL")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-element-bodymatter toc-item-element-type-chapter has-leading-number has-no-children has-no-page-number"
  }, [_c('p', {
    staticClass: "element-title"
  }, [_c('span', {
    staticClass: "element-number"
  }, [_vm._v("24. ")]), _c('span', {
    attrs: {
      "href": "#/chapter024",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "element-title-text"
  }, [_vm._v("ROUEN")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-element-bodymatter toc-item-element-type-chapter has-leading-number has-no-children has-no-page-number"
  }, [_c('p', {
    staticClass: "element-title"
  }, [_c('span', {
    staticClass: "element-number"
  }, [_vm._v("25. ")]), _c('span', {
    attrs: {
      "href": "#/chapter025",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "element-title-text"
  }, [_vm._v("SYL")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-element-bodymatter toc-item-element-type-chapter has-leading-number has-no-children has-no-page-number"
  }, [_c('p', {
    staticClass: "element-title"
  }, [_c('span', {
    staticClass: "element-number"
  }, [_vm._v("26. ")]), _c('span', {
    attrs: {
      "href": "#/chapter026",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "element-title-text"
  }, [_vm._v("ROUEN")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-element-bodymatter toc-item-element-type-chapter has-leading-number has-no-children has-no-page-number"
  }, [_c('p', {
    staticClass: "element-title"
  }, [_c('span', {
    staticClass: "element-number"
  }, [_vm._v("27. ")]), _c('span', {
    attrs: {
      "href": "#/chapter027",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "element-title-text"
  }, [_vm._v("SYL")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-element-bodymatter toc-item-element-type-chapter has-leading-number has-no-children has-no-page-number"
  }, [_c('p', {
    staticClass: "element-title"
  }, [_c('span', {
    staticClass: "element-number"
  }, [_vm._v("28. ")]), _c('span', {
    attrs: {
      "href": "#/chapter028",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "element-title-text"
  }, [_vm._v("ROUEN")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-element-bodymatter toc-item-element-type-chapter has-leading-number has-no-children has-no-page-number"
  }, [_c('p', {
    staticClass: "element-title"
  }, [_c('span', {
    staticClass: "element-number"
  }, [_vm._v("29. ")]), _c('span', {
    attrs: {
      "href": "#/chapter029",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "element-title-text"
  }, [_vm._v("SYL")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-element-bodymatter toc-item-element-type-chapter has-leading-number has-no-children has-no-page-number"
  }, [_c('p', {
    staticClass: "element-title"
  }, [_c('span', {
    staticClass: "element-number"
  }, [_vm._v("30. ")]), _c('span', {
    attrs: {
      "href": "#/chapter030",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "element-title-text"
  }, [_vm._v("ROUEN")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-element-bodymatter toc-item-element-type-epilogue has-no-leading-number has-no-children has-no-page-number"
  }, [_c('p', {
    staticClass: "element-title"
  }, [_c('span', {
    attrs: {
      "href": "#/epilogue",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "element-title-text"
  }, [_vm._v("Epilogue")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-backmatter-group"
  }, [_c('div', {
    staticClass: "toc-item toc-item-element-non-bodymatter toc-item-element-type-also-by has-no-leading-number has-no-children has-no-page-number"
  }, [_c('p', {
    staticClass: "element-title"
  }, [_c('span', {
    attrs: {
      "href": "#/theseriescontinueswitheidolon",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "element-title-text"
  }, [_vm._v("The Series Continues with Eidolon")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-element-non-bodymatter toc-item-element-type-none has-no-leading-number has-no-children has-no-page-number"
  }, [_c('p', {
    staticClass: "element-title"
  }, [_c('span', {
    attrs: {
      "href": "#/reviewrequest",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "element-title-text"
  }, [_vm._v("Review Request")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-element-non-bodymatter toc-item-element-type-also-by has-no-leading-number has-no-children has-no-page-number"
  }, [_c('p', {
    staticClass: "element-title"
  }, [_c('span', {
    attrs: {
      "href": "#/moribund",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "element-title-text"
  }, [_vm._v("Moribund")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-element-non-bodymatter toc-item-element-type-also-by has-no-leading-number has-no-children has-no-page-number"
  }, [_c('p', {
    staticClass: "element-title"
  }, [_c('span', {
    attrs: {
      "href": "#/derailed",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "element-title-text"
  }, [_vm._v("Derailed")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-element-non-bodymatter toc-item-element-type-also-by has-no-leading-number has-no-children has-no-page-number"
  }, [_c('p', {
    staticClass: "element-title"
  }, [_c('span', {
    attrs: {
      "href": "#/ouroboros",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "element-title-text"
  }, [_vm._v("Ouroboros")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-element-non-bodymatter toc-item-element-type-also-by has-no-leading-number has-no-children has-no-page-number"
  }, [_c('p', {
    staticClass: "element-title"
  }, [_c('span', {
    attrs: {
      "href": "#/dethroned",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "element-title-text"
  }, [_vm._v("Dethroned")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-element-non-bodymatter toc-item-element-type-also-by has-no-leading-number has-no-children has-no-page-number"
  }, [_c('p', {
    staticClass: "element-title"
  }, [_c('span', {
    attrs: {
      "href": "#/inimical",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "element-title-text"
  }, [_vm._v("Inimical")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-element-non-bodymatter toc-item-element-type-also-by has-no-leading-number has-no-children has-no-page-number"
  }, [_c('p', {
    staticClass: "element-title"
  }, [_c('span', {
    attrs: {
      "href": "#/rekindled",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "element-title-text"
  }, [_vm._v("Rekindled")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-element-non-bodymatter toc-item-element-type-also-by has-no-leading-number has-no-children has-no-page-number"
  }, [_c('p', {
    staticClass: "element-title"
  }, [_c('span', {
    attrs: {
      "href": "#/nemesis",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "element-title-text"
  }, [_vm._v("Nemesis")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-element-non-bodymatter toc-item-element-type-also-by has-no-leading-number has-no-children has-no-page-number"
  }, [_c('p', {
    staticClass: "element-title"
  }, [_c('span', {
    attrs: {
      "href": "#/eidolon",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "element-title-text"
  }, [_vm._v("Eidolon")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-element-non-bodymatter toc-item-element-type-also-by has-no-leading-number has-no-children has-no-page-number"
  }, [_c('p', {
    staticClass: "element-title"
  }, [_c('span', {
    attrs: {
      "href": "#/thegirlintheglassbox",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "element-title-text"
  }, [_vm._v("The Girl in the Glass Box")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-element-non-bodymatter toc-item-element-type-also-by has-no-leading-number has-no-children has-no-page-number"
  }, [_c('p', {
    staticClass: "element-title"
  }, [_c('span', {
    attrs: {
      "href": "#/theadventuresofmarisolholmesbymajankaverstraete",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "element-title-text"
  }, [_vm._v("The Adventures of Marisol Holmes by Majanka Verstraete")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-element-non-bodymatter toc-item-element-type-acknowledgments has-no-leading-number has-no-children has-no-page-number"
  }, [_c('p', {
    staticClass: "element-title"
  }, [_c('span', {
    attrs: {
      "href": "#/acknowledgments",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "element-title-text"
  }, [_vm._v("Acknowledgments")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-element-non-bodymatter toc-item-element-type-about-author has-no-leading-number has-no-children has-no-page-number"
  }, [_c('p', {
    staticClass: "element-title"
  }, [_c('span', {
    attrs: {
      "href": "#/abouttheauthor",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "element-title-text"
  }, [_vm._v("About the Author")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-element-non-bodymatter toc-item-element-type-none has-no-leading-number has-no-children has-no-page-number"
  }, [_c('p', {
    staticClass: "element-title"
  }, [_c('span', {
    attrs: {
      "href": "#/newsletterlinks",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "element-title-text"
  }, [_vm._v("Newsletter Links")])])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-31f1d30c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/contents.vue
// module id = 60
// module chunks = 0